(function(){
  const $ = (selector, context = document) => context.querySelector(selector);
  const $$ = (selector, context = document) => Array.from(context.querySelectorAll(selector));
  const THEME = window.DEROUW_THEME || {};
  const CARD_TEXT_TTL_MS = 24 * 60 * 60 * 1000;
  const store = {
    get text(){
      const saved = Number(localStorage.getItem('derouw_card_text_v2_saved_at') || 0);
      if(saved && (Date.now() - saved) > CARD_TEXT_TTL_MS){
        localStorage.removeItem('derouw_card_text_v2');
        localStorage.removeItem('derouw_card_text_v2_saved_at');
        return '';
      }
      return localStorage.getItem('derouw_card_text_v2') || '';
    }, 
    set text(v){
      if(v){
        localStorage.setItem('derouw_card_text_v2', v);
        localStorage.setItem('derouw_card_text_v2_saved_at', String(Date.now()));
      } else {
        localStorage.removeItem('derouw_card_text_v2');
        localStorage.removeItem('derouw_card_text_v2_saved_at');
      }
    },
    get ship(){ return localStorage.getItem('derouw_ship_date') || ''; },
    set ship(v){ localStorage.setItem('derouw_ship_date', v || ''); }
  };
  function nextBusinessDays(count){
    const out=[]; let d=new Date(); d.setHours(12,0,0,0); d.setDate(d.getDate()+1);
    while(out.length<count){ const day=d.getDay(); if(day!==0 && day!==1 && day!==6) out.push(new Date(d)); d.setDate(d.getDate()+1); }
    return out;
  }
  function iso(d){ return d.toISOString().split('T')[0]; }
  function labelDate(d){ return d.toLocaleDateString('nl-NL',{weekday:'short',day:'2-digit',month:'2-digit'}); }
  function escapeHtml(value){ return String(value||'').replace(/[&<>'"]/g, c=>({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c])); }
  function showSaved(){ $$('.kaart-saved').forEach(el=>{ el.classList.add('show'); clearTimeout(el._t); el._t=setTimeout(()=>el.classList.remove('show'),1600); }); }
  function ensureDefaults(){
    if(!store.text){ const src=$('[data-card-source]'); if(src && src.value) store.text=src.value; }
    if(!store.ship){ const days=nextBusinessDays(2); store.ship=iso(days[0]); }
  }
  function currentCardText(){
    const active=document.activeElement && document.activeElement.matches && document.activeElement.matches('[data-card-source], textarea[name="properties[Kaarttekst]"]') ? document.activeElement : null;
    const src=active || $('[data-card-source]') || $('textarea[name="properties[Kaarttekst]"]');
    const value=src ? (src.value || '') : '';
    if(value.trim()) store.text=value;
    ensureDefaults();
    return store.text;
  }
  function syncProperties(scope){
    ensureDefaults(); const text=store.text; const ship=store.ship;
    $$('[data-card-source]').forEach(el=>{ if(document.activeElement!==el && text) el.value=text; });
    (scope?$$('input[name="properties[Kaarttekst]"], textarea[name="properties[Kaarttekst]"]',scope):$$('input[name="properties[Kaarttekst]"], textarea[name="properties[Kaarttekst]"]')).forEach(el=>{ if(document.activeElement!==el) el.value=text; });
    (scope?$$('input[name="properties[Verzenddatum]"]',scope):$$('input[name="properties[Verzenddatum]"]')).forEach(el=>el.value=ship);
  }
  function renderShipChoices(){
    const days=nextBusinessDays(2); if(!store.ship) store.ship=iso(days[0]);
    $$('[data-ship-options]').forEach(wrap=>{
      wrap.innerHTML=days.map((d,i)=>`<button type="button" class="date-pill${store.ship===iso(d)?' active':''}" data-ship-select="${iso(d)}"><span class="dd">${labelDate(d)}</span><span class="dm">${i===0?'Eerstvolgende werkdag':'Werkdag erna'}</span></button>`).join('');
    });
    syncProperties();
  }
  function injectProperties(formData){
    const text=currentCardText(); ensureDefaults();
    if(text) formData.set('properties[Kaarttekst]', text);
    if(store.ship) formData.set('properties[Verzenddatum]', store.ship);
  }
  async function saveCartAttributes(){
    currentCardText(); ensureDefaults();
    try{
      await fetch('/cart/update.js',{
        method:'POST',
        headers:{'Content-Type':'application/json'},
        credentials:'same-origin',
        body:JSON.stringify({attributes:{Kaarttekst:store.text||'',Verzenddatum:store.ship||''}})
      });
    }catch(e){}
  }
  async function addCardProductIfConfigured(){
    let id=(THEME.cardVariantId||'').trim();
    const text=store.text;
    if(!id){
      const handles=[(THEME.cardProductHandle||'').trim(),'gepersonaliseerd-kaartje','persoonlijk-kaartje','kaartje','persoonlijke-kaart','persoonlijk-kaartje-190'].filter(Boolean);
      for(const handle of [...new Set(handles)]){
        try{ const product=await fetch('/products/'+encodeURIComponent(handle)+'.js',{credentials:'same-origin'}).then(r=>r.ok?r.json():null); if(product && product.variants && product.variants[0]){ id=String(product.variants[0].id); break; } }catch(e){}
      }
    }
    if(!id || !text) { window.DEROUW_CARD_MISSING_VARIANT=true; return false; }
    window.DEROUW_CARD_MISSING_VARIANT=false;
    try{
      const existing=await fetch('/cart.js',{credentials:'same-origin'}).then(r=>r.json());
      const already=(existing.items||[]).some(item=>String(item.id)===String(id) && item.properties && item.properties._kaartje==='true' && item.properties.Kaarttekst===text);
      if(already){ window.DEROUW_CARD_MISSING_VARIANT=false; return true; }
      const fd=new FormData();
      fd.set('id', id);
      fd.set('quantity','1');
      fd.set('properties[Kaarttekst]', text);
      fd.set('properties[Verzenddatum]', store.ship || '');
      fd.set('properties[_kaartje]', 'true');
      await fetch('/cart/add.js',{method:'POST',body:fd,credentials:'same-origin'});
      window.DEROUW_CARD_MISSING_VARIANT=false;
      return true;
    }catch(e){ return false; }
  }
  function openCart(){ $('.drawer-overlay')?.classList.add('show'); $('.drawer')?.classList.add('show'); refreshCart(); }
  function closeCart(){ $('.drawer-overlay')?.classList.remove('show'); $('.drawer')?.classList.remove('show'); }
  window.DRouwCart={open:openCart,close:closeCart,refresh:refreshCart};
  async function refreshCart(){ try{ const cart=await fetch('/cart.js',{credentials:'same-origin'}).then(r=>r.json()); renderCart(cart); }catch(e){} }
  function money(cents){ return (cents/100).toLocaleString('nl-NL',{style:'currency',currency:'EUR'}); }
  function formatDate(value){
    if(!value) return '';
    const m=String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
    return m ? `${m[3]}-${m[2]}-${m[1]}` : String(value);
  }  
  function isCardItem(item){
    const title=(item.product_title||item.title||'').toLowerCase();
    return (item.properties && item.properties._kaartje==='true') || title.includes('kaartje') || title.includes('kaart');
  }
  function renderCart(cart){
    $$('.cartcount').forEach(el=>el.textContent=cart.item_count||0);
    const body=$('.drawer-body'); const total=$('[data-cart-total]'); if(total) total.textContent=money(cart.total_price||0); if(!body)return;
    const hasCardProduct=(cart.items||[]).some(isCardItem);
    if(hasCardProduct) window.DEROUW_CARD_MISSING_VARIANT=false;
    const cardText=store.text||cart.attributes?.Kaarttekst||'';
    const shipText=formatDate(store.ship||cart.attributes?.Verzenddatum||'');
    const savedCard = (cardText && !hasCardProduct) ? `<div class="cart-card-note"><strong>Persoonlijk kaartje</strong><p>${escapeHtml(cardText)}</p>${shipText?`<small class="cart-card-line">Verzenddatum: ${escapeHtml(shipText)}</small>`:''}${window.DEROUW_CARD_MISSING_VARIANT?'<small class="cart-card-line">Het persoonlijk kaartje wordt zo spoedig mogelijk toegevoegd aan uw bestelling.</small>':''}</div>` : '';
    if(!cart.items.length){ body.innerHTML=savedCard + '<div class="empty"><span class="display">Uw winkelmand is leeg</span><p>Kies een cadeau om te versturen.</p></div>'; return; }
    body.innerHTML=savedCard + cart.items.map((item,index)=>{
      const props=Object.entries(item.properties||{}).filter(([k,v])=>v&&!String(k).startsWith('_')).map(([k,v])=>`${escapeHtml(k)}: ${escapeHtml(v)}`).join('<br>');
      return `<div class="citem"><a href="${item.url}" class="citem-art">${item.image?`<img src="${item.image}" alt="${escapeHtml(item.product_title)}">`:''}</a><div class="citem-info"><a href="${item.url}" class="cn">${escapeHtml(item.product_title)}</a>${props?`<div class="cmeta">${props}</div>`:''}<div class="citem-bot"><div><button data-cart-change="${index+1}" data-qty="${item.quantity-1}">−</button> <span>${item.quantity}</span> <button data-cart-change="${index+1}" data-qty="${item.quantity+1}">+</button></div><div class="cprice">${money(item.final_line_price)}</div></div></div></div>`;
    }).join('');
  }
  document.addEventListener('click',async event=>{
    const menuOpen=event.target.closest('[data-menu-open]'); if(menuOpen){event.preventDefault();document.body.classList.add('menu-open');$('.mobnav')?.classList.add('show');}
    const menuClose=event.target.closest('[data-menu-close]'); if(menuClose){event.preventDefault();document.body.classList.remove('menu-open');$('.mobnav')?.classList.remove('show');}
    if(event.target.closest('.mobnav a')) { document.body.classList.remove('menu-open'); $('.mobnav')?.classList.remove('show'); }
    const open=event.target.closest('[data-cart-open]'); if(open){event.preventDefault();syncProperties();openCart();}
    const close=event.target.closest('[data-cart-close]'); if(close){event.preventDefault();closeCart();}
    const example=event.target.closest('[data-use-example]'); if(example){event.preventDefault();store.text=example.getAttribute('data-use-example')||'';syncProperties();showSaved();}
    const ship=event.target.closest('[data-ship-select]'); if(ship){event.preventDefault();store.ship=ship.dataset.shipSelect;renderShipChoices();showSaved();}
    const save=event.target.closest('[data-save-card]'); if(save){ currentCardText(); syncProperties(); showSaved(); await saveCartAttributes(); if(save.hasAttribute('data-add-card-only')){ event.preventDefault(); await addCardProductIfConfigured(); openCart(); } }
    const jump=event.target.closest('[data-scroll-to]'); if(jump){ currentCardText(); syncProperties(); const target=document.getElementById(jump.dataset.scrollTo); if(target){event.preventDefault();target.scrollIntoView({behavior:'smooth'});} }
    const change=event.target.closest('[data-cart-change]'); if(change){event.preventDefault();await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},credentials:'same-origin',body:JSON.stringify({line:Number(change.dataset.cartChange),quantity:Number(change.dataset.qty)})});refreshCart();}
  });
  document.addEventListener('input',event=>{ if(event.target.matches('[data-card-source], textarea[name="properties[Kaarttekst]"]')){ store.text=event.target.value||''; syncProperties(); showSaved(); } });
  document.addEventListener('change',event=>{ if(event.target.matches('[data-card-source], textarea[name="properties[Kaarttekst]"]')){ store.text=event.target.value||''; syncProperties(); showSaved(); } });
  document.addEventListener('formdata',event=>{ if(event.target && event.target.matches && event.target.matches('form[action*="/cart/add"]')) injectProperties(event.formData); });
  document.addEventListener('submit',async event=>{
    const form=event.target.closest('form[data-ajax-cart], form[action*="/cart/add"]'); if(!form)return;
    event.preventDefault();
    currentCardText(); syncProperties(form); 
    const fd=new FormData(form);
    fd.delete('properties[Kaarttekst]');
    fd.delete('properties[Verzenddatum]');
    try{
      const res = await fetch('/cart/add.js',{method:'POST',body:fd,credentials:'same-origin'});
      if(!res.ok){
        let msg = 'Dit product kon helaas niet worden toegevoegd.'; 
        try{ const err = await res.json(); if(err.description) msg = err.description; }catch(e){}
        const errEl = form.querySelector('[data-cart-error]') || (() => { const d=document.createElement('p'); d.setAttribute('data-cart-error',''); d.style.cssText='color:#a22137;font-size:.85rem;margin:.5rem 0 0'; form.appendChild(d); return d; })();
        errEl.textContent = msg;
        return; 
      }
      form.querySelector('[data-cart-error]')?.remove();
      await saveCartAttributes(); await addCardProductIfConfigured(); openCart();
    }
    catch(e){ form.submit(); }
  }, true);
  document.addEventListener('DOMContentLoaded',()=>{ document.body.classList.remove('menu-open'); document.querySelectorAll('.mobnav.show').forEach(el=>el.classList.remove('show')); ensureDefaults(); renderShipChoices(); syncProperties(); refreshCart(); });
  window.addEventListener('pageshow',()=>{ document.body.classList.remove('menu-open'); document.querySelectorAll('.mobnav.show').forEach(el=>el.classList.remove('show')); ensureDefaults(); renderShipChoices(); syncProperties(); });
  window.addEventListener('beforeunload',()=>{ currentCardText(); });
  // v27: na een filter- of themaklik direct naar het assortiment scrollen.
  if(window.location.hash === '#assortiment') {
    setTimeout(() => {
      const assortiment = document.getElementById('assortiment');
      if(assortiment) assortiment.scrollIntoView({behavior:'auto', block:'start'});
    }, 80);
  }
})();
